import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/osc_consort_homes.png")